<template>
  <div class="page-wrap">

    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <div class="panel-header__icon">
          <i class="fa fa-percent"></i>
        </div>
        <div class="panel-header__text">
          <div class="panel-header__title">
            {{ isEdit ? 'Edit Promocode' : 'Create Promocode' }}
          </div>
          <div class="panel-header__sub">Discount and promo code settings</div>
        </div>
        <div class="panel-header__action">
          <button class="btn-back" @click="goBack()">
            <i class="fa fa-arrow-left"></i> Back
          </button>
        </div>
      </div>

      <!-- Toggle row -->
      <div class="toggle-row">
        <div class="toggle-item">
          <div class="toggle-item__info">
            <span class="toggle-item__label">Active</span>
          </div>
          <label class="toggle-switch">
            <input type="checkbox" v-model="is_active" id="status_switch" />
            <span class="toggle-switch__track"></span>
          </label>
        </div>
      </div>

      <!-- Form -->
      <div class="form-section">
        <div class="fields-grid">

          <div class="field-wrap">
            <label class="field-label">Title <span class="req">*</span></label>
            <input
              type="text"
              class="field-input"
              :class="{ 'field-input--error': errors['title'] }"
              v-model="title"
              placeholder="Enter title"
            />
            <span class="field-error" v-if="errors['title']">{{ errors['title'][0] }}</span>
          </div>

          <div class="field-wrap">
            <label class="field-label">Company Name</label>
            <input
              type="text"
              class="field-input"
              :class="{ 'field-input--error': errors['company_name'] }"
              v-model="company_name"
              placeholder="Enter company name"
            />
            <span class="field-error" v-if="errors['company_name']">{{ errors['company_name'][0] }}</span>
          </div>

          <div class="field-wrap">
            <label class="field-label">Discount (%) <span class="req">*</span></label>
            <div class="input-affix">
              <input
                type="number"
                min="0"
                class="field-input field-input--suffix"
                :class="{ 'field-input--error': errors['discount_percentage'] }"
                v-model="discount_percentage"
                placeholder="0"
              />
              <span class="input-affix__suffix">%</span>
            </div>
            <span class="field-error" v-if="errors['discount_percentage']">{{ errors['discount_percentage'][0] }}</span>
          </div>

          <div class="field-wrap">
            <label class="field-label">Valid Date Range <span class="req">*</span></label>
            <date-picker
              valueType="MM/DD/YYYY"
              v-model="expireDate"
              format="MM/DD/YYYY"
              :disabled-date="notAfterToday"
              class="date-picker-wrap"
              range
            ></date-picker>
            <span class="field-error" v-if="errors['valid_from']">{{ errors['valid_from'][0] }}</span>
          </div>

        </div>
      </div>

      <div style="height: 72px;"></div>
    </div>

    <!-- Floating save bar -->
    <div class="save-bar">
      <div class="save-bar__left"></div>
      <div class="save-bar__right">
        <button class="save-bar__back" @click="goBack()">
          <i class="fa fa-arrow-left"></i> Back
        </button>
        <button
          v-if="!isEdit"
          class="save-bar__secondary"
          ref="kt_save_add_another_company"
          @click="store('SAA', 'kt_save_add_another_company')"
        >
          <i class="fa fa-plus"></i> Save &amp; Add Another
        </button>
        <button
          v-if="!isEdit"
          class="save-bar__submit"
          ref="kt_save_company"
          @click="store('S', 'kt_save_company')"
        >
          <i class="fa fa-check"></i> Save
        </button>
        <button
          v-if="isEdit"
          class="save-bar__submit"
          ref="kt_update_company_data"
          @click="update('kt_update_company_data')"
        >
          <i class="fa fa-check"></i> Update
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import {
  STORE_PROMOCODE,
  GET_PROMOCODE_DATA,
  UPDATE_PROMOCODE
} from "@/core/services/store/actions.type";
export default {
  data() {
    return {
      isEdit: false,
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "client.dashboard" },
        { id: 2, title: "Promocodes", route: "client.promocode" },
        { id: 3, title: "Create New Promocode", route: "" }
      ],
      title: "",
      discount_percentage: 0,
      company_name: "",
      is_active: false,
      expireDate: "",
      errors: []
    };
  },
  created() {
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    this.isEdit = this.$route.name == "client.promocode.edit" ? true : false;
    var id = this.$route.params.id;
    if (this.isEdit) {
      this.breadCrumbs[2].title = "";
      this.$store
        .dispatch(GET_PROMOCODE_DATA, id)
        .then(data => {
          this.breadCrumbs[2].title = "Edit | " + data.title;
          this.title = data.title;
          this.discount_percentage = data.discount_percentage;
          this.is_active = data.is_active;
          this.company_name = data.company_name;
          this.expireDate = [
            this.$moment(data.valid_from).format("MM/DD/YYYY"),
            this.$moment(data.valid_to).format("MM/DD/YYYY")
          ];
        })
        .catch(() => {
          this.$toastr.e("Promocode not found!");
          this.$router.push({ name: "client.promocode" });
        });
    }
  },
  methods: {
    notAfterToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    goBack() {
      this.$router.push({
        name: "client.promocode",
        params: { client_slug: this.$route.params.client_slug }
      });
    },
    clearForm() {
      this.discount_percentage = 0;
      this.is_active = false;
      this.expireDate = "";
      this.title = "";
      this.company_name = "";
    },
    closeBtnLoad(ref) {
      const btn = this.$refs[ref];
      btn.classList.remove("spinner", "spinner-light", "spinner-right");
      btn.disabled = false;
    },
    loadingButton(ref) {
      const btn = this.$refs[ref];
      btn.disabled = true;
      btn.classList.add("spinner", "spinner-light", "spinner-right");
    },
    update(ref) {
      var valid_from = "";
      var valid_to = "";
      this.expireDate = this.expireDate == "," ? "" : this.expireDate;
      if (this.expireDate != "") {
        var exp = this.expireDate;
        valid_from = this.$moment(exp[0]).format("YYYY-MM-DD");
        valid_to = this.$moment(exp[1]).format("YYYY-MM-DD");
      }
      this.errors = [];
      this.loadingButton(ref);
      this.$store
        .dispatch(UPDATE_PROMOCODE, {
          id: this.$route.params.id,
          title: this.title,
          discount_percentage: this.discount_percentage,
          is_active: this.is_active,
          valid_from: valid_from,
          valid_to: valid_to,
          company_name: this.company_name
        })
        .then(data => {
          if (data.code == 200) {
            this.$toastr.s(data.msg);
            this.closeBtnLoad(ref);
            this.$router.push({ name: "client.promocode" });
          } else {
            this.$toastr.w(data.msg);
            this.closeBtnLoad(ref);
          }
        })
        .catch(err => {
          this.errors = err;
          this.closeBtnLoad(ref);
        });
    },
    store(saveType, ref) {
      var valid_from = "";
      var valid_to = "";
      this.expireDate = this.expireDate == "," ? "" : this.expireDate;
      if (this.expireDate != "") {
        var exp = this.expireDate;
        valid_from = this.$moment(exp[0]).format("YYYY-MM-DD");
        valid_to = this.$moment(exp[1]).format("YYYY-MM-DD");
      }
      this.errors = [];
      this.loadingButton(ref);
      this.$store
        .dispatch(STORE_PROMOCODE, {
          id: 0,
          discount_percentage: this.discount_percentage,
          is_active: this.is_active,
          company_name: this.company_name,
          title: this.title,
          valid_from: valid_from,
          valid_to: valid_to
        })
        .then(data => {
          this.$toastr.s(data.msg);
          this.closeBtnLoad(ref);
          if (saveType == "S") {
            this.$router.push({ name: "client.promocode" });
          } else if (saveType == "SAA") {
            this.clearForm();
          }
        })
        .catch(err => {
          this.errors = err;
          this.closeBtnLoad(ref);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
$font:   'Segoe UI', sans-serif;
$blue:   #389ad4;
$dark:   #0d1b3e;
$green:  #276749;
$border: #dde2ec;

/* ── page ── */
.page-wrap {
  padding: 12px;
  font-family: $font;
  padding-bottom: 100px;
}

/* ── panel card ── */
.panel-card {
  background: #fff;
  border: 1px solid $border;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  max-width: 760px;
  margin: 0 auto;
}

/* ── header ── */
.panel-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
  border-bottom: 1px solid $border;
  background: linear-gradient(135deg, #f8faff 0%, #f0f5ff 100%);

  &__icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(135deg, $blue, #2277aa);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 18px;
    flex-shrink: 0;
  }

  &__text { flex: 1; }

  &__title {
    font-size: 16px;
    font-weight: 700;
    color: $dark;
    line-height: 1.2;
  }

  &__sub {
    font-size: 12px;
    color: #7a8499;
    margin-top: 3px;
  }

  &__action { flex-shrink: 0; }
}

.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f0f3fa;
  color: $dark;
  border: 1.5px solid $border;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  font-family: $font;
  cursor: pointer;
  transition: background 0.15s;

  &:hover { background: #e4eaf5; }
}

/* ── toggle row ── */
.toggle-row {
  display: flex;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid $border;
  background: #fafbfd;
}

.toggle-item {
  display: flex;
  align-items: center;
  gap: 14px;

  &__info { display: flex; flex-direction: column; }

  &__label {
    font-size: 13px;
    font-weight: 500;
    color: $dark;
  }
}

.toggle-switch {
  position: relative;
  display: inline-flex;
  cursor: pointer;
  flex-shrink: 0;

  input { position: absolute; opacity: 0; width: 0; height: 0; }

  &__track {
    display: block;
    width: 40px;
    height: 22px;
    background: #d0d5e0;
    border-radius: 11px;
    transition: background 0.2s;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      top: 3px;
      left: 3px;
      width: 16px;
      height: 16px;
      background: #fff;
      border-radius: 50%;
      transition: transform 0.2s;
      box-shadow: 0 1px 3px rgba(0,0,0,0.2);
    }
  }

  input:checked + &__track {
    background: $blue;
    &::after { transform: translateX(18px); }
  }
}

/* ── form section ── */
.form-section { padding: 24px; }

.fields-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px 20px;
}

/* ── fields ── */
.field-wrap {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.field-label {
  font-size: 12px;
  font-weight: 500;
  color: #5a6480;
}

.req { color: #e53935; }

.field-input {
  height: 40px;
  border: 1.5px solid $border;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 13px;
  font-family: $font;
  color: $dark;
  background: #fafbfd;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
  width: 100%;

  &::placeholder { color: #b0bac9; }

  &:focus {
    border-color: $blue;
    box-shadow: 0 0 0 3px rgba(56,154,212,0.12);
    background: #fff;
  }

  &--error {
    border-color: #e53935;
    &:focus { box-shadow: 0 0 0 3px rgba(229,57,53,0.1); }
  }

  &--suffix { padding-right: 36px; }
}

/* ── % suffix ── */
.input-affix {
  position: relative;

  &__suffix {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 13px;
    color: #9aa0b0;
    pointer-events: none;
    font-weight: 500;
  }
}

.field-error { font-size: 11px; color: #e53935; }

/* date picker override */
.date-picker-wrap {
  width: 100%;

  :deep(.mx-input) {
    height: 40px;
    border: 1.5px solid $border;
    border-radius: 8px;
    font-size: 13px;
    font-family: $font;
    color: $dark;
    background: #fafbfd;
    padding: 0 12px;
    box-shadow: none;
    transition: border-color 0.15s;

    &:focus { border-color: $blue; }
  }
}

input[type="number"] {
  -moz-appearance: textfield !important;
  appearance: textfield;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* ── floating save bar ── */
.save-bar {
  position: fixed;
  bottom: 2.5rem;
  width: calc(78vw);
  left: 50%;
  transform: translateX(-40%);
  background: #1a2340;
  border-radius: 14px;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 8px 32px rgba(0,0,0,0.25);
  z-index: 200;

  &__left { flex: 1; }

  &__right {
    display: flex;
    align-items: center;
    gap: 10px;
  }

&__back {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: rgba(255,255,255,0.1);
    color: #fff;
    border: 1.5px solid rgba(255,255,255,0.2);
    border-radius: 8px;
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 500;
    font-family: $font;
    cursor: pointer;
    transition: background 0.15s;

    &:hover { background: rgba(255,255,255,0.18); }
  }

  &__secondary {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: rgba(255,255,255,0.12);
    color: #fff;
    border: 1.5px solid rgba(255,255,255,0.25);
    border-radius: 8px;
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 500;
    font-family: $font;
    cursor: pointer;
    transition: background 0.15s;

    &:hover { background: rgba(255,255,255,0.2); }
  }

  &__submit {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: $blue;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 8px 22px;
    font-size: 13px;
    font-weight: 600;
    font-family: $font;
    cursor: pointer;
    transition: background 0.15s, box-shadow 0.15s;

    &:hover {
      background: #2d85bb;
      box-shadow: 0 4px 14px rgba(56,154,212,0.4);
    }

    &:disabled { opacity: 0.6; cursor: not-allowed; }
  }
}

</style>
